import React from "react";
import { Tooltip } from "@progress/kendo-react-tooltip";

const BorrowingEntitiesTooltip = ({ children, entities }) => (
  <Tooltip
    anchorElement="target"
    position="right"
    content={() => entities.map((...args) => React.cloneElement(args[0], { key: args[1] }))}
    showCallout={false}
    tooltipStyle={{
      maxWidth: "300px",
      lineHeight: "1.4em",
      backgroundColor: "rgba(97, 97, 97, 0.9)",
      boxSizing: "content-box"
    }}
    parentTitle
  >
    <div title="Borrowing entities">{children}</div>
  </Tooltip>
);

export default BorrowingEntitiesTooltip;
